'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isObject = isObject;
exports.isArray = isArray;
exports.isDate = isDate;
exports.isNumber = isNumber;
exports.isBoolean = isBoolean;
exports.isString = isString;
exports.isFunction = isFunction;
exports.typeForDisplay = typeForDisplay;
exports.isUndefined = isUndefined;
exports.isNull = isNull;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _kindOf = require('kind-of');

var _kindOf2 = _interopRequireDefault(_kindOf);

function isObject(obj) {
  return (0, _kindOf2['default'])(obj) === 'object';
}

function isArray(arr) {
  return (0, _kindOf2['default'])(arr) === 'array';
}

function isDate(obj) {
  return (0, _kindOf2['default'])(obj) === 'date';
}

function isNumber(obj) {
  return (0, _kindOf2['default'])(obj) === 'number';
}

function isBoolean(obj) {
  return (0, _kindOf2['default'])(obj) === 'boolean';
}

function isString(obj) {
  return (0, _kindOf2['default'])(obj) === 'string';
}

function isFunction(obj) {
  return (0, _kindOf2['default'])(obj) === 'function';
}

function typeForDisplay(obj) {
  return upperCaseFirst((0, _kindOf2['default'])(obj));
}

function isUndefined(obj) {
  return (0, _kindOf2['default'])(obj) === 'undefined';
}

function isNull(obj) {
  return (0, _kindOf2['default'])(obj) === 'null';
}

function upperCaseFirst(str) {
  if (!isString(str)) {
    return str;
  }
  var first = str.slice(0, 1).toUpperCase();
  var rest = str.slice(1, str.length);
  return first + rest;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/shared/type-utils.js
// module id = 10
// module chunks = 0